module.exports = __webpack_public_path__ + "static/bett1aces_locations_1080x1080_tempelhof-sm-47a7767ffa528786da21a3ccb48ae4a9.gif";